module.exports = __webpack_public_path__ + "jab/media/lock.f2d167ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/lock.svg
// module id = 1477
// module chunks = 0